import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, BarsArrowUpIcon } from "@heroicons/react/24/outline";
import { useRecoilState } from "recoil";
import TextInput from "../../../../../components/TextInput";
import SelectInput from "../../../../../components/SelectInput";
import SearchButton from "../../../../../components/SearchButton";
import RefreshButton from "../../../../../components/RefreshButton";
import { defaultVoidedSearchData } from "../../InvoiceCapture/atoms/atoms";
import useSearchVoided from "../hooks/useSearchVoided";

const VoidedFilters = ({ data, setFilteredVoided, setIsSearching }) => {
  const [searchInputsData, setSearchInputsData] = useRecoilState(
    defaultVoidedSearchData
  );
  const { mutate: SearchData } = useSearchVoided();

  //Invoice No. dropdown
  const invoiceNumberOpt = data
    ?.filter(
      (value, index, self) =>
        self.findIndex(
          (t) =>
            t.invoiceNumber === value.invoiceNumber && t.invoiceNumber !== null
        ) === index
    )
    .map((x: { invoiceNumber: number }) => {
      return {
        value: x.invoiceNumber,
        label: x.invoiceNumber,
        invoiceNumber: x.invoiceNumber,
      };
    });

  //Batch No Dropdown
  const BatchNoOpt = data?.map((x: { id: number }) => {
    return {
      value: x.id,
      label: x.id,
      id: x.id,
    };
  });

  //Bill reference no. dropdown
  const billReferenceOpt = data
    ?.filter(
      (value, index, self) =>
        self.findIndex(
          (t) =>
            t.billRefNumber === value.billRefNumber &&
            t.billRefNumber !== null &&
            t.billRefNumber !== ""
        ) === index
    )
    .map((x: { billRefNumber: string }) => {
      return {
        value: x.billRefNumber,
        label: x.billRefNumber,
        billRefNumber: x.billRefNumber,
      };
    });

  const RefreshData = () => {
    setIsSearching(false);
    setFilteredVoided([]);
    setSearchInputsData({
      ...searchInputsData,
      ServiceAccountNo: "",
      BatchNo: 0,
      TaxId: "",
      DateCreatedFrom: "",
      DateCreatedTo: "",
      BillRefNumber: "",
      InvoiceNumber: "",
    });
  };

  return (
    <>
      <div className="pr-3 space-y-2">
        <div>
          <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
          <div className="text-xl font-bold text-primary -mt-9 ml-8">
            Search Section
          </div>
        </div>
        <div className="w-full">
          <div className="mb-3">
            <Disclosure defaultOpen>
              {({ open }) => (
                <>
                  <Disclosure.Button className="sm:px-2 flex justify-between w-full mb-2 px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                    <span className="whitespace-nowrap mr-4">
                      Voided Details
                    </span>
                    <ChevronDownIcon
                      className={`${
                        open ? "transform rotate-180" : ""
                      } w-5 h-5 text-gray-500`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                    <div className="w-full">
                      <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                        <div>
                          <label className="block font-medium text-gray-700 mb-2">
                            Invoice No.
                          </label>
                          <div className="w-full">
                            <SelectInput
                              options={invoiceNumberOpt}
                              className={undefined}
                              onChange={(e) => {
                                setSearchInputsData({
                                  ...searchInputsData,
                                  InvoiceNumber: e ? e.value : null,
                                });
                              }}
                              value={invoiceNumberOpt?.filter(
                                (x) =>
                                  x.value === searchInputsData.InvoiceNumber
                              )}
                              components={undefined}
                              field={undefined}
                              isLoading={undefined}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                        <div>
                          <label className="block font-medium text-gray-700 mb-2">
                            Bill Reference No.
                          </label>
                          <div className="w-full">
                            <SelectInput
                              options={billReferenceOpt}
                              className={undefined}
                              onChange={(e) => {
                                setSearchInputsData({
                                  ...searchInputsData,
                                  BillRefNumber: e ? e.value : null,
                                });
                              }}
                              value={billReferenceOpt?.filter(
                                (x) =>
                                  x.value === searchInputsData.BillRefNumber
                              )}
                              components={undefined}
                              field={undefined}
                              isLoading={undefined}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                        <div>
                          <label className="block font-medium text-gray-700 mb-2">
                            Batch No.
                          </label>
                          <div className="w-full">
                            <SelectInput
                              options={BatchNoOpt}
                              className={undefined}
                              onChange={(e) => {
                                setSearchInputsData({
                                  ...searchInputsData,
                                  BatchNo: e ? e.value : null,
                                });
                              }}
                              value={BatchNoOpt?.filter(
                                (x) => x.value === searchInputsData.BatchNo
                              )}
                              components={undefined}
                              field={undefined}
                              isLoading={undefined}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                        <div>
                          <label className="block font-medium text-gray-700 mb-2">
                            Date Created From
                          </label>
                          <div className="w-full">
                            <TextInput
                              value={searchInputsData.DateCreatedFrom}
                              onChange={(e) => {
                                setSearchInputsData({
                                  ...searchInputsData,
                                  DateCreatedFrom: e ? e.target.value : null,
                                });
                              }}
                              type="date"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                        <div>
                          <label className="block font-medium text-gray-700 mb-2">
                            Date Created To
                          </label>
                          <div className="w-full">
                            <TextInput
                              value={searchInputsData.DateCreatedTo}
                              onChange={(e) => {
                                setSearchInputsData({
                                  ...searchInputsData,
                                  DateCreatedTo: e ? e.target.value : null,
                                });
                              }}
                              type="date"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center items-end gap-x-2 mb-12 rounded-md py-4">
                        <SearchButton
                          buttonValue="Search"
                          className={"opacity-100"}
                          onClick={() => {
                            SearchData(
                              {
                                ...searchInputsData,
                              },
                              {
                                onSuccess: (res) => {
                                  setFilteredVoided(res?.data);
                                },
                              }
                            );
                            setIsSearching(true);
                          }}
                        />
                        <RefreshButton
                          onClick={() => {
                            RefreshData();
                          }}
                        />
                      </div>
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        </div>
      </div>
    </>
  );
};

export default VoidedFilters;
